// extracted by mini-css-extract-plugin
module.exports = {"stack":"LayoutStack_stack__IFjsf","container":"LayoutStack_container__Qw8hD","flex":"LayoutStack_flex__h6fY2"};